import { useQuery } from '@apollo/client';
import useBusinessConfiguration from '../../../hooks/useBusinessConfiguration';
import GET_LANDING_PAGE from './GET_LANDING_PAGE';
var useLandingPage = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var _l = useBusinessConfiguration(), program = _l.program, tenant = _l.tenant;
    // Define CMS Content Names
    var landingPageContentName = "".concat(tenant, "RefreshmentsLandingPage");
    var _m = useQuery(GET_LANDING_PAGE, {
        variables: {
            program: program,
            landingPageContentName: landingPageContentName,
        },
        errorPolicy: 'ignore',
    }), data = _m.data, loading = _m.loading, error = _m.error;
    var layout = data === null || data === void 0 ? void 0 : data.me.layout;
    var landingPageContent = layout === null || layout === void 0 ? void 0 : layout.landingPageContent;
    var faqSectionContent = {
        faqLinkText: (_a = landingPageContent === null || landingPageContent === void 0 ? void 0 : landingPageContent.faqLinkText) !== null && _a !== void 0 ? _a : '',
        faqLinkUrl: (_b = landingPageContent === null || landingPageContent === void 0 ? void 0 : landingPageContent.faqLinkUrl) !== null && _b !== void 0 ? _b : '',
    };
    var socialMediaSectionContent = {
        socialMediaTitle: (_c = landingPageContent === null || landingPageContent === void 0 ? void 0 : landingPageContent.socialMediaTitle) !== null && _c !== void 0 ? _c : '',
        socialMediaTiktokUrl: (_d = landingPageContent === null || landingPageContent === void 0 ? void 0 : landingPageContent.socialMediaTiktokUrl) !== null && _d !== void 0 ? _d : '',
        socialMediaInstagramUrl: (_e = landingPageContent === null || landingPageContent === void 0 ? void 0 : landingPageContent.socialMediaInstagramUrl) !== null && _e !== void 0 ? _e : '',
        socialMediaFacebookUrl: (_f = landingPageContent === null || landingPageContent === void 0 ? void 0 : landingPageContent.socialMediaFacebookUrl) !== null && _f !== void 0 ? _f : '',
    };
    var socialMediaSectionPosts = (_j = (_h = (_g = data === null || data === void 0 ? void 0 : data.me.subscriptionProgram) === null || _g === void 0 ? void 0 : _g.socialMedia) === null || _h === void 0 ? void 0 : _h.instagram) === null || _j === void 0 ? void 0 : _j.posts;
    return {
        error: error,
        loading: loading,
        userId: data === null || data === void 0 ? void 0 : data.me.id,
        subscription: data === null || data === void 0 ? void 0 : data.me.subscription,
        currentStarterKit: (_k = data === null || data === void 0 ? void 0 : data.me.subscriptionProgram) === null || _k === void 0 ? void 0 : _k.starterkitSlug,
        faqSectionContent: faqSectionContent,
        socialMediaSectionContent: socialMediaSectionContent,
        socialMediaSectionPosts: socialMediaSectionPosts,
    };
};
export default useLandingPage;
